<template>
  <section id="skills">
    <div class="container">
      <div class="content-bg">
        <h1 class="text-center">Skills</h1>
        <p>Web technologies I can work with:</p>
        <hr class="skills__line" />
        <p class="milli">HTML5 | CSS3 ( OOCSS & BEM ) | SASS | Accessibility</p>
        <p class="milli">JavaScript(+ES6) | AJAX | JSON | Fetch API | REST API</p>
        <p class="milli">Vue.js | React | Bootstrap | Materialize CSS</p>
        <p class="milli">Babel | Webpack | Git | Github</p>
        <p class="milli">Node | PHP | MySQL | Firebase</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Skills'
}
</script>
